import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaUser, FaShoppingCart, FaSearch } from 'react-icons/fa';
import { useShoppingCart } from '../../context/ShoppingCartContext';

export default function Header() {
  const { getCartCount } = useShoppingCart();
  const cartCount = getCartCount();
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      navigate(`/?search=${encodeURIComponent(searchTerm.trim())}`);
      setSearchTerm('');
    }
  };

  return (
    <header className="header">
      <div className="header-container">
        {/* Logo jote - e madhe */}
        <Link to="/" className="logo">
          <img 
            src="/logo-full.png" 
            alt="Orendion" 
            style={{ height: '80px', width: 'auto' }} 
          />
        </Link>
        
        <form onSubmit={handleSearch} className="search-bar">
          <input
            type="text"
            placeholder="Kërko produkte..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button type="submit" className="search-btn">
            <FaSearch />
          </button>
        </form>
        
        <div className="header-icons">
          <Link to="/login"><FaUser /> Llogaria</Link>
          <Link to="/cart" style={{ position: 'relative' }}>
            <FaShoppingCart /> Shporta
            {cartCount > 0 && (
              <span style={{
                position: 'absolute',
                top: '-8px',
                right: '-12px',
                background: '#e74c3c',
                color: 'white',
                borderRadius: '50%',
                width: '18px',
                height: '18px',
                fontSize: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                {cartCount}
              </span>
            )}
          </Link>
        </div>
      </div>
    </header>
  );
}